import Model, { ID, Integer, MODEL_LEVEL } from 'src/models/model'

export default class UserClass extends Model {
  static name = 'UserClass'

  static isConfiguration = true

  static deletable = true

  static versioned = true

  static level = MODEL_LEVEL.CIRCUIT

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Circuit]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        default: null,
        translatable: true
      },
      displayOrder: {
        type: Integer,
        default: 100
      },
      minAge: {
        type: Integer,
        default: null
      },
      maxAge: {
        type: Integer,
        default: null
      },
      description: {
        type: String,
        default: null,
        translatable: true
      },
      availableOnline: {
        type: Boolean,
        default: true
      },
      internal: {
        type: Boolean,
        default: false
      },
      ageDescription: {
        type: String,
        output: true,
        default: null
      }
    }

    this.computed = {
      defaultUserClass () {
        // First user class is the default
        return _(this.configuration.userClasses?.data).filter({ internal: false }).first()
      },
      defaultOnlineUserClass () {
        // First user class is the default
        return _(this.configuration.userClasses?.data).filter({ availableOnline: true, internal: false }).first()
      },
      isDefault () {
        return (this.defaultOnlineUserClass?.id && this.defaultOnlineUserClass.id === this.id) ||
          (!this.defaultOnlineUserClass?.id && this.defaultUserClass?.id && this.defaultUserClass.id === this.id)
      }
    }
  }
}
